import { useCallback, useState } from 'react';

export const useModalControl = (initialState = false) => {
  const [modalOpen, setModalOpen] = useState(initialState);
  const showModal = useCallback(() => setModalOpen(true), [setModalOpen]);
  const hideModal = useCallback(() => setModalOpen(false), [setModalOpen]);
  return [modalOpen, { showModal, hideModal }] as const;
};
